import React, { Component } from 'react';
import styles from '../scss/Download.scss';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export class ContactForm extends Component {

    state = {
        contactInfo: {
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            org: "",
            comments: ""
        },
        errors: {},
        valid: false,
    }

    componentDidMount() {
        this.restoreContactInfo();
    }

    restoreContactInfo = () => {
        const contactInfoString = localStorage.getItem("contactInfo");
        if (contactInfoString) {
            const contactInfo = JSON.parse(contactInfoString);
            this.setState({
                contactInfo: contactInfo
            }, () => {
                this.validate();
            });
        }
        // this.validate();
    }

    handleChange = (event) => {
        let contactInfo = { ...this.state.contactInfo };
        contactInfo[event.target.name] = event.target.value;

        this.setState({ contactInfo }, () => {
            localStorage.setItem("contactInfo", JSON.stringify(contactInfo));
            this.validate();
        });
    }

    handleContinue = (event) => {

        const isValid = this.validate();
        if (this.props.onValidate) {
            this.props.onValidate(isValid);
        }

        // if (this.validate()) {

        //     if (this.props.onContinue) {
        //         this.props.onContinue();
        //     }

        //     // let contactInfo = {
        //     //     firstName: "",
        //     //     lastName: "",
        //     //     email: "",
        //     //     phoneNumber: "",
        //     //     org: "",
        //     //     comments: ""
        //     // };

        //     // this.setState({ contactInfo: contactInfo });
        // }
    }

    validate = () => {
        let contactInfo = this.state.contactInfo;
        let errors = {};
        let isValid = true;

        if (!contactInfo["firstName"]) {
            isValid = false;
            errors["firstName"] = "Please enter your first name.";
        }

        if (!contactInfo["lastName"]) {
            isValid = false;
            errors["lastName"] = "Please enter your last name.";
        }

        if (!contactInfo["email"]) {
            isValid = false;
            errors["email"] = "Please enter your email Address.";
        }

        if (typeof contactInfo["email"] !== "undefined") {

            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(contactInfo["email"])) {
                isValid = false;
                errors["email"] = "Please enter valid email address.";
            }
        }

        if (!contactInfo["phoneNumber"]) {
            isValid = false;
            errors["phoneNumber"] = "Please enter your phone number.";
        }

        if (!contactInfo["org"]) {
            isValid = false;
            errors["org"] = "Please enter name of your organization.";
        }

        if (!contactInfo["comments"]) {
            isValid = false;
            errors["comments"] = "Please enter your comments.";
        }

        this.setState({
            errors: errors,
            valid: isValid
        });


        if (this.props.onValidate) {
            this.props.onValidate(isValid);
        }

        return isValid;
    }


    render() {
        return (
            <div className="request-container" >

                <div className="request-container-header">
                    Provide your contact information:
                </div>
                <div className="request-container-content">
                    <form>
                        <div className="form-group">
                            <label htmlFor="firstName">First Name:</label>
                            <input
                                type="text"
                                name="firstName"
                                value={this.state.contactInfo.firstName}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="Enter first name"
                                id="firstName" />

                            <div className="text-danger">{this.state.errors.firstName}</div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="lastName">Last Name:</label>
                            <input
                                type="text"
                                name="lastName"
                                value={this.state.contactInfo.lastName}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="Enter last name"
                                id="lastName" />

                            <div className="text-danger">{this.state.errors.lastName}</div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email Address:</label>
                            <input
                                type="text"
                                name="email"
                                value={this.state.contactInfo.email}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="Enter email"
                                id="email" />

                            <div className="text-danger">{this.state.errors.email}</div>
                        </div>


                        <div className="form-group">
                            <label htmlFor="phoneNumber">Phone Number:</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={this.state.contactInfo.phoneNumber}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="Enter phone number"
                                id="phoneNumber" />

                            <div className="text-danger">{this.state.errors.phoneNumber}</div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="org">Organization:</label>
                            <input
                                type="text"
                                name="org"
                                value={this.state.contactInfo.org}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder="Enter name of your organization"
                                id="org" />

                            <div className="text-danger">{this.state.errors.org}</div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="comments">Purpose of Data Request:</label>
                            <textarea
                                name="comments"
                                value={this.state.contactInfo.comments}
                                onChange={this.handleChange}
                                placeholder="How will the data be used?"
                                className="form-control" />

                            <div className="text-danger">{this.state.errors.comments}</div>
                        </div>

                    </form>
                </div>
            </div>
        )
    }
}

export default ContactForm
